import { createReducer, on } from '@ngrx/store';

import { setRefreshTimerAction } from '@shared/refresh-search/store/actions/refresh-search.actions';

export const initialState = false;

export const refreshTimerReducer = createReducer(
  initialState,
  on(setRefreshTimerAction, (state, { refreshed }) => refreshed)
);
